export default __webpack_public_path__ + "static/media/mall.8c078d03.png";